import { Badge, Box, Heading, Text } from '@wix/design-system';
import { FunctionComponent } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import css from './index.module.scss';
import { DATA_HOOKS } from '../../../dataHooks';
import { AIMediumIcon } from '../../../icons/AIMediumIcon';


export type GenAnswerHeaderProps = {
  searchQuestion: string;

};
export const GenAnswerHeader: FunctionComponent<GenAnswerHeaderProps> = (
  { searchQuestion }
) => {
  const { t } = useTranslation();

  return (
    <Box direction="horizontal" className={css.genAnswerHeader}>
      <Box direction="horizontal" display='inline' className={css.headerText}>
        <Box className={css.aiIconWrapper}>
          <AIMediumIcon />
        </Box>
        <Heading dataHook={DATA_HOOKS.GEN_ANSWER_HEADING}>
          <Text className={css.aiAnswer}>
            {t('search-results-page.gen-answer.AI-answer')}
          </Text>
          <Text dataHook={DATA_HOOKS.GEN_ANSWER_QUESTION} className={css.searchQuestion}>{`for "${searchQuestion}"`}</Text>
        </Heading>
      </Box>
      <Box className={css.betaDisclaimerWrapper} dataHook={DATA_HOOKS.BETA_GEN_ANSWER}>
        <Badge className={css.betaDisclaimer} uppercase={false} skin="neutralLight" type="outlined">
          {t('search-results-page.gen-answer.beta')}
        </Badge>
      </Box>
    </Box>
  );
};
